import numbro from 'numbro';

export enum FileType {
  SCRIPT,
  TEXT,
  PROGRAM,
  ARCHIVE,
  BACKUP,
  INSTALLATION,
  OTHER,
  UNKNOWN,
}

export const formatFileSize = (size: number): string => {
  let formattedSize: string;
  if (size < 1024) {
    formattedSize = numbro(size).format(`0 b`);
  } else {
    formattedSize = numbro(size).format(`0.0 b`).replace(/i/, '');
  }
  return formattedSize;
};

export const getFileType = (file: string | undefined): FileType => {
  if (file) {
    const extension = file.replace(/.*\./, '');
    switch (extension) {
      case 'zip':
        return FileType.ARCHIVE;
      case 'urp':
        return FileType.PROGRAM;
      case 'script':
        return FileType.SCRIPT;
      case 'installation':
        return FileType.INSTALLATION;
      default:
        if (extension.search(/^old\d/) === 0) {
          return FileType.BACKUP;
        }
        return FileType.OTHER;
    }
  } else {
    return FileType.UNKNOWN;
  }
};

/**
 * This util function determines whether a valid mime type is an image.
 * It will return undefined if the mime type is invalid.
 *
 * @param mimeType expects a valid mime type (e.g. image/png, text/csv, etc.)
 * @returns boolean if the mimeType is valid, undefined if invalid
 */
export const isImage = (mimeType: string): boolean => {
  return mimeType.startsWith('image');
};

export const isPDF = (mimeType: string): boolean => {
  return mimeType.startsWith('application/pdf');
};
